export const UPDATE_SUBSCRIBER_QUERY_KEY = ['update', 'subscriber'] as const;

export const COMMUNICATION_MODE_FIELD_NAME = 'communication_mode' as const;
export const EMAIL_FIELD_NAME = 'email' as const;
export const SECONDARY_EMAIL_FIELD_NAME = 'email2' as const;
export const CELLPHONE_FIELD_NAME = 'cell_phone' as const;
export const SMS_FIELD_NAME = 'receive_text_messages' as const;

export const FORM_FIELDS = {
  email: 'email',
  email2: 'email',
  cell_phone: 'tel',
  communication_mode: null,
  receive_text_messages: null,
};
